<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <p class="mb-5 text-justify">
        Ingresar rango de fechas de los rechazos que desea consultar.
      </p>

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        pagination
        filtro
        showExportToExcel
        :showFilterDates="true"
        @click-event="clickEvent"
        @click-buscar="buscar"
        :perPage="perPage"
        :dataLength="dataLength"
      >
        <table-column
          slot="label"
          customClass="text-center"
          :label="'Modelo'"
          v-bind:value="'modelo'"
        ></table-column>
        <table-column
          slot="label"
          customClass="text-center"
          :label="'Fecha Reclamación'"
          v-bind:value="'fecha_reclamacion'"
        ></table-column>
        <table-column
          slot="label"
          customClass="text-center"
          :label="'Cédula'"
          v-bind:value="'cedula'"
        ></table-column>
        <table-column
          slot="label"
          customClass="text-center"
          :label="'Pagaré'"
          v-bind:value="'pagare'"
        ></table-column>
        <table-column
          slot="label"
          customClass="text-center"
          :label="'Código'"
          v-bind:value="'convenio'"
        ></table-column>
        <table-column
          slot="label"
          customClass="text-center"
          :label="'Tipo de Rechazo'"
          v-bind:value="'detalle'"
        ></table-column>
        <table-column
          slot="label"
          customClass="text-center"
          :label="'Descripción'"
          v-bind:value="'descripcion'"
        ></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      perPage: 25,
      informe_url: "informes/rechazo",
      fileName: "Rechazo ",
      fecha_inicio: this.$moment().startOf("month").format("YYYY-MM-DD"),
      fecha_fin: this.$moment().format("YYYY-MM-DD"),
      nRows: 25,
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading",
    }),
    dataLength() {
      return this.$store.getters["pages/dataInformes"].paginacion.total;
    },
    data() {
      return this.$store.getters["pages/dataInformes"].datos;
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    buscar(event) {
      this.fecha_inicio = event.fecha_inicio;
      this.fecha_fin = event.fecha_fin;
      this.perPage = event.nRows;
      this.loadData(event.nRows);
    },
    async clickEvent(data, slug) {
      switch (slug) {
        case "paginacion":
          this.loadData(data.nRows, data.page);
          break;
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            let result = await this.$store.state.api.get(this.informe_url, {
              params: {
                fecha_inicio: this.$store.getters["table/dateInicio"],
                fecha_fin: this.$store.getters["table/dateFin"],
                paginar: false,
              },
            });
            let data = XLSX.utils.json_to_sheet(result.data.datos, {
              header: [
                "modelo",
                "fecha_reclamacion",
                // "fecha_rechazo",
                "cedula",
                "pagare",
                "convenio",
                "descripcion",
                "detalle",
              ],
            });

            data["A1"].v = "Modelo";
            data["B1"].v = "Fecha de reclamación";
            // data["C1"].v = "Fecha de rechazo";
            data["C1"].v = "Cédula";
            data["D1"].v = "Pagaré";
            data["E1"].v = "Código";
            data["F1"].v = "Descripción del rechazo";
            data["G1"].v = "Detalle";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, data, this.fileName);
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              this.fileName + ".xlsx"
            );
            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
      }
    },
    loadData(row, page = 1, paginar = true) {
      this.$store.dispatch("pages/fetch", {
        endpoint: this.informe_url,
        params: {
          row: this.perPage,
          page: page,
          paginar: paginar,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
        },
      });
    },
  },
  mounted() {
    this.loadData(this.perPage, 1);
  },
};
</script>